import { z } from 'zod'

export const geocodingSuggestionSchema = z.object({
  mapboxId: z.string(),
  name: z.string(),
  fullAddress: z.string(),
  street: z.string().nullable(),
  city: z.string().nullable(),
  country: z.string().nullable(),
})

export const geocodingResultSchema = geocodingSuggestionSchema.extend({
  lat: z.number(),
  lng: z.number(),
})

export const geocodingSuggestResponseSchema = z.array(geocodingSuggestionSchema)
export const geocodingForwardResponseSchema = z.array(geocodingResultSchema)

export type GeocodingSuggestion = z.infer<typeof geocodingSuggestionSchema>
export type GeocodingResult = z.infer<typeof geocodingResultSchema>
export type GeocodingSuggestResponse = z.infer<typeof geocodingSuggestResponseSchema>
export type GeocodingForwardResponse = z.infer<typeof geocodingForwardResponseSchema>
